import * as types from '../types'

const defaultState = {
  pageConfig: []
}

export default function roleConfig(state = defaultState, action = {}) {
  const { type, payload } = action
  const res = Object.assign({}, state)
  switch (type) {
    // 添加配置
    case types.ROLE_ADD_PAGE_CONFIG:
      let obj = {}, arr = []
      // const groupArr = [...res.pageConfig, ...payload.config]
      const groupArr = [...payload.config]
      // for(let i =0,len=groupArr.length;i<len;i++) {
      //   if(!obj[groupArr[i].title]) {
      //     arr.push(groupArr[i])
      //     obj[groupArr[i].title] = 1
      //   }
      // }
      return Object.assign({}, state, {pageConfig: groupArr})

      break
    case type.ROL_SET_PAGE_CONFIG:
      // res.pageConfig = payload.config
      break
    default:

  }
  return res
}